import { render } from "./basic_Init.vue?vue&type=template&id=1c1bab3a"
import script from "./basic_Init.vue?vue&type=script&lang=js"
export * from "./basic_Init.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__